export enum ApprovalStatus {
  YES = 'Yes',
  NO = 'No',
}
